import NiceModal from '@ebay/nice-modal-react';

import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import DCPickList from 'pages/Shipments/PrintOrders/DCPickList';
import DispatchingUnit from 'pages/Shipments/PrintOrders/DispatchingUnit';
import InternationalProforma from 'pages/Shipments/PrintOrders/InternationalProforma';
import PickListPDF from 'pages/Shipments/PrintOrders/PickListPDF';
import PrintAWB from 'pages/Shipments/PrintOrders/PrintAWB';
import PrintBranchLabel from 'pages/Shipments/PrintOrders/PrintBranchLabel';
import PrintOrders from 'pages/Shipments/PrintOrders/PrintOrders';
import PrintOrdersWithAWB from 'pages/Shipments/PrintOrders/PrintOrdersWithAWB';
import ReturnShipmentDetails from 'pages/Shipments/PrintOrders/ReturnShipmentDetails';

import axios, { setAuthorizationToken } from 'services/axios';

import AppLogger from 'utils/AppLogger';

const ExternalPrint = () => {
	const [params] = useSearchParams();

	useEffect(() => {
		const token = params.get('token');
		if (token) {
			axios.defaults.headers.common.authorization = `Bearer ${token}`;
			setAuthorizationToken(token);
		} else {
			AppLogger.error('ExternalPrint: Cannot find access token in the URL');
			return;
		}

		const type = params.get('type');

		let orderID = params.get('orderID');
		const dispatchingUnitID = params.get('dispatchingUnitID');

		if (orderID?.includes(',')) {
			orderID = orderID.split(',').map((id) => Number(id));
		}

		const ids = Array.isArray(orderID) ? orderID : [Number(orderID)];

		const ClientName = params.get('ClientName');
		const VATNumber = params.get('VATNumber');
		const language = params.get('language');

		switch (type) {
			case 'printAwb':
				NiceModal.show(PrintAWB, {
					ids,
					defaultLang: language || 'engValue'
				});
				return;
			case 'printReturnAWB':
				NiceModal.show(PrintAWB, {
					ids,
					reverse: true,
					defaultLang: language || 'engValue'
				});
				return;
			case 'printOrderWithAWB':
				NiceModal.show(PrintOrdersWithAWB, {
					ids,
					defaultLang: language || 'engValue',
					clientData: {
						ClientName: ClientName || '',
						VATNumber: VATNumber || '000000000000000'
					}
				});
				return;
			case 'printPickupList':
				NiceModal.show(DCPickList, {
					ids,
					defaultLang: language || 'engValue'
				});
				return;
			case 'printOrders':
				NiceModal.show(PrintOrders, {
					ids,
					defaultLang: language || 'engValue',
					clientData: {
						ClientName: ClientName || '',
						VATNumber: VATNumber || '000000000000000'
					}
				});
				return;
			case 'printBranchLabel':
				NiceModal.show(PrintBranchLabel, {
					ids,
					defaultLang: language || 'engValue',
					clientData: {
						ClientName: ClientName || '',
						VATNumber: VATNumber || '000000000000000'
					}
				});
				return;
			case 'pickListPDF':
				NiceModal.show(PickListPDF, {
					ids,
					defaultLang: language || 'engValue'
				});
				return;
			case 'printInternationalProforma':
				NiceModal.show(InternationalProforma, {
					ids
				});
				return;
			case 'printDispatchingUnit':
				NiceModal.show(DispatchingUnit, {
					id: dispatchingUnitID,
					defaultLang: language || 'engValue'
				});
				return;
			case 'returnShipmentDetails':
				NiceModal.show(ReturnShipmentDetails, {
					ids
				});
				return;
			default:
				return;
		}
	}, []);

	return undefined;
};

export default ExternalPrint;
